// Interfaces
import { createReducer } from '@reduxjs/toolkit';

import { DeviceOrientation } from '../../enums';

import * as AppReadoutActions from './actions';
import { Constants } from './constants';
import { IAppReadoutsState } from './interfaces';

const initialAppReadoutState: IAppReadoutsState = {
    mediaSize: null,
    scrollTop: undefined,
    isSystemErrorMounted: false,
    isConfigLoaded: false,
    requestState: false,
    isAnonymousPageMounted: false,
    routeFriendlyName: null,
    supportedLanguages: undefined,
    progress: undefined,
    hideExemptPopup: true,
    orientation: DeviceOrientation.portrait,
};

export const appReadoutsReducer = createReducer(initialAppReadoutState, {
    [Constants.APP_READOUTS_SETMEDIASIZE]: (draftState, action: ReturnType<typeof AppReadoutActions.setMediaSize>) => {
        draftState.mediaSize = action.payload.size;
    },

    [Constants.APP_READOUTS_SET_CONFIG_LOADED]: (
        draftState,
        action: ReturnType<typeof AppReadoutActions.setConfigLoaded>
    ) => {
        draftState.isConfigLoaded = action.payload.isConfigLoaded;
    },

    [Constants.APP_READOUTS_SET_SCROLL_TOP]: (
        draftState,
        action: ReturnType<typeof AppReadoutActions.setScrollTop>
    ) => {
        draftState.scrollTop = action.payload.top;
    },

    [Constants.APP_READOUTS_SYSTEM_ERROR_MOUNTED]: (
        draftState,
        action: ReturnType<typeof AppReadoutActions.systemErrorMounted>
    ) => {
        draftState.isSystemErrorMounted = action.payload.mounted;
    },

    [Constants.APP_READOUTS_SET_REQUEST_STATE]: (
        draftState,
        action: ReturnType<typeof AppReadoutActions.setRequestState>
    ) => {
        draftState.requestState = action.payload.state;
    },

    [Constants.APP_READOUTS_SET_LANGUAGES]: (
        draftState,
        action: ReturnType<typeof AppReadoutActions.setSupportedLanguages>
    ) => {
        draftState.supportedLanguages = action.payload.languages;
    },

    [Constants.APP_READOUTS_HIDE_EXEMPT_POPUP]: (
        draftState,
        action: ReturnType<typeof AppReadoutActions.setHideExemptPopup>
    ) => {
        draftState.hideExemptPopup = action.payload.hide;
    },

    [Constants.APP_READOUTS_SET_ORIENTATION]: (
        draftState,
        action: ReturnType<typeof AppReadoutActions.setOrientation>
    ) => {
        draftState.orientation = action.payload.orientation;
    },
});
